import { formatDate } from '../utils/authUtils';

/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: 'c0b12fe9-80c6-4247-8ea8-3e10aa3df0fc',
    title: 'The Batman',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Shobit Deshwal',
    videoId: 'mqqft2x_Aa4',
    likes: 0,
    dislikes: 0,
    views: 0,
    category: ['Action'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1efc-4086-aa19-4dc7ed4f0b41',
    title: 'Spiderman: No Way Home',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'ZYzbalQ6Lg8',
    likes: 10,
    dislikes: 0,
    views: 69,
    category: ['Action'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1efc-4086-aa19-4dc7easfw0b41',
    title: 'Avengers: Endgame',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'TcMBFSGVi1c',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1efc-4086-aa19-4ntfsfw0b41',
    title: 'Fantastic Beasts',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'yA7HyhOpC-k',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action', 'Sci-fi'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1efc-4086-aa19-4dcsgwersfw0b41',
    title: 'Man of Steel',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'T6DJcgm3wNY',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1efc-4086-aaghneasfw0b41',
    title: 'Fury',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'q94n3eWOWXM',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-wrgwehas-4dc7easfw0b41',
    title: 'Batman Begins',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'neY2xVmOfUM',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3baqwertq44086-aa19-4dc7easfw0b41',
    title: 'King Kong',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: '4rgo4yeC3C4',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1efc-4wret3qfgqasfw0b41',
    title: 'Me Before You',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'Eh993__rOxA',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1efc-4086-aatiktasfw0b41',
    title: 'Interstellar',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'zSWdZVtXT7E',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Sci-fi'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-hryjtj-aa19-4dc7easfw0b41',
    title: 'Matrix',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: '9ix7TUGVYIo',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-qwer-4dc7easfw0b41',
    title: 'The Fault in our stars',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: '9ItBvH5J6ss',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1sfegwertg9-4dc7easfw0b41',
    title: 'The Pursuit of Happiness',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'DMOBlEcRuw8',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babf0-1ehe5trhr-4dc7easfw0b41',
    title: 'Theory of Everything',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'Salz7uGp72c',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babfregerw6-aa19-4dc7easfw0b41',
    title: '300',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'UrIbxk7idYA',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babfresdfsdfsdfqew7easfw0b41',
    title: 'October',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Rising Sun Films',
    videoId: '7vracgLyJwI',
    likes: 25,
    dislikes: 2,
    views: 456,
    category: ['Romance', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'abasdfgerw6-aa19-4dc7easfw0b41',
    title: 'Alice In Wonderland',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'WonderLand',
    videoId: 'Cjq79pZ4ZHA',
    likes: 95,
    dislikes: 12,
    views: 145,
    category: ['Action', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'asdw3fgbfregerw6-aa19-4dc7easfw0b41',
    title: 'MEN IN BLACK: INTERNATIONAL',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Sony Pictures',
    videoId: 'BV-WEb2oxLk',
    likes: 9129,
    dislikes: 23,
    views: 1234230,
    category: ['Action', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'gergh46-aa19-4dc7easfw0b41',
    title: 'The Martian',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: '20th Century FOX',
    videoId: 'ej3ioOneTy8',
    likes: 99,
    dislikes: 0,
    views: 234,
    category: ['Action', 'Fiction'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ngfkregerw6-aa19-4dc7easfw0b41',
    title: 'BLADE RUNNER 2049',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Warner Bros. Pictures',
    videoId: 'gCcx85zbxz4',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action', 'Fiction'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'zxcweyregerw6-aa19-4dc7easfw0b41',
    title: 'VENOM',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Sony Pictures Entertainment',
    videoId: 'u9Mv98Gr5pY',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action', 'Fiction'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'fgnypegerw6-aa19-4dc7easfw0b41',
    title: 'Rogue One: A Star Wars Story',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Star Wars',
    videoId: 'frdj1zb9sMY',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action', 'Fiction'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'arghjofregerw6-aa19-4dc7easfw0b41',
    title: 'Jurassic Park',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Sony',
    videoId: 'lc0UehYemQA',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action', 'Fiction'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'zzsxdregerw6-aa19-4dc7easfw0b41',
    title: 'Mad Max: Fury Road',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Warner Bros. Pictures',
    videoId: 'hEJnMQG9ev8',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action', 'Fiction'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'xczxdfregerw6-aa19-4dc7easfw0b41',
    title: 'Fifty Shades Of Grey',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Universal Pictures',
    videoId: 'SfZWFDs0LxA',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'qwe3vregerw6-aa19-4dc7easfw0b41',
    title: 'Titanic (1997)',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Sony',
    videoId: 'jUm88F3MEbQ',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'zcewqregerw6-aa19-4dc7easfw0b41',
    title: 'PASSENGERS ',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Sony',
    videoId: '7BWWWQzTpNU',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance', 'Fiction'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'cvbeerw6-aa19-4dc7easfw0b41',
    title: 'The Princess and the Bodyguard',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Reel One Entertainment',
    videoId: '5eivkIIWjXY',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance'],
    uploadedAt: formatDate(),
  },
  {
    _id: 't234sd6-aa19-4dc7easfw0b41',
    title: 'Silent Love',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Codcast Channel',
    videoId: 'KuuEs0oVVS8',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romatic'],
    uploadedAt: formatDate(),
  },
  {
    _id: '43qfdafregerw6-aa19-4dc7easfw0b41',
    title: 'The Big Sick',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Holly Hunter',
    videoId: 'jcD0Daqc3Yw',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babfregerw6-aarg42easfw0b41',
    title: 'Shrek (2001)',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Marvel',
    videoId: 'CwXOrWvPBPk',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babfregenf6r7easfw0b41',
    title: 'The Proposal',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Sony',
    videoId: 'Z2lYA7L7PZY',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Romance', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babfregegw54geag9-4dc7easfw0b41',
    title: 'THE SHAPE OF WATER',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Searchlight Pictures',
    videoId: 'XFYWazblaUA',
    likes: 99,
    dislikes: 0,
    views: 10000,
    category: ['Action', 'Drama'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babfgwerg5w9-4dc7easfw0b41',
    title: 'Edge of Tomorrow',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Warner Bros. Pictures',
    videoId: 'vw61gCe2oqI',
    likes: 29,
    dislikes: 1,
    views: 56567,
    category: ['Sci-fi'],
    uploadedAt: formatDate(),
  },
  {
    _id: 'ab3babgeerga19-4dc7easfw0b41',
    title: 'WALL-E',
    description:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
    creator: 'Sony',
    videoId: 'CZ1CATNbXg0',
    likes: 12,
    dislikes: 135,
    views: 513,
    category: ['Sci-fi'],
    uploadedAt: formatDate(),
  },
];
